<template>
  <div class="user-settings-view">
    <!-- Toast powiadomienie -->
    <div v-if="showToast" class="success-toast">
      ✓ Ustawienia zostały zapisane
    </div>

    <!-- Header -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">⚙️ Ustawienia konta</h1>
        <p class="page-subtitle">Zarządzaj swoim profilem i preferencjami</p>
      </div>
      <router-link to="/" class="btn-back">
        ← Powrót
      </router-link>
    </div>

    <div class="settings-container">
      <form @submit.prevent="updateProfile()">
        <!-- Sekcja 1: Dane osobowe -->
        <div class="settings-section">
          <div class="section-header">
            <h2 class="section-title">
              <span class="section-icon">👤</span>
              Dane osobowe
            </h2>
          </div>
          <div class="section-body">
            <div class="form-group">
              <label class="form-label">Imię i nazwisko</label>
              <input
                v-if="userProfile"
                class="form-input"
                v-model.trim="name"
                type="text"
                :placeholder="userProfile.name"
              />
              <input
                v-else
                class="form-input"
                v-model.trim="name"
                type="text"
                placeholder="Imię i nazwisko"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Email</label>
              <input
                class="form-input"
                :placeholder="currentUserEmail || 'Ładowanie...'"
                type="email"
                disabled
              />
              <span class="helper-text">Adres email nie może być zmieniony</span>
            </div>
          </div>
        </div>

        <!-- Sekcja 2: Limity pobierania danych -->
        <div class="settings-section">
          <div class="section-header">
            <h2 class="section-title">
              <span class="section-icon">📊</span>
              Limity pobierania danych
            </h2>
            <p class="section-description">
              Określ maksymalną liczbę rekordów pobieranych z bazy danych
            </p>
          </div>
          <div class="section-body">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">
                  👥 Kontrahenci
                  <span class="count-badge">{{ contractorsCount }}</span>
                </label>
                <input
                  class="form-input"
                  v-model.number="limitContractors"
                  type="number"
                  min="100"
                  max="5000"
                  :placeholder="defaultLimitContractors.toString()"
                />
              </div>
              <div class="form-group">
                <label class="form-label">
                  🔧 Instalacje
                  <span class="count-badge">{{ installationsCount }}</span>
                </label>
                <input
                  class="form-input"
                  v-model.number="limitInstallations"
                  type="number"
                  min="100"
                  max="5000"
                  :placeholder="defaultLimitInstallations.toString()"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">
                  💰 Płatności
                  <span class="count-badge">{{ paymentsCount }}</span>
                </label>
                <input
                  class="form-input"
                  v-model.number="limitPayments"
                  type="number"
                  min="100"
                  max="5000"
                  :placeholder="defaultLimitPayments.toString()"
                />
              </div>
              <div class="form-group">
                <label class="form-label">
                  📦 Magazyn
                  <span class="count-badge">{{ magazineCount }}</span>
                </label>
                <input
                  class="form-input"
                  v-model.number="limitMagazine"
                  type="number"
                  min="100"
                  max="5000"
                  :placeholder="defaultLimitMagazine.toString()"
                />
              </div>
            </div>
            <div class="info-box">
              <span class="info-icon">ℹ️</span>
              <span>Wyższe limity mogą wpłynąć na wydajność aplikacji</span>
            </div>
          </div>
        </div>

        <!-- Sekcja 3: Domyślne wartości ofert -->
        <div class="settings-section">
          <div class="section-header">
            <h2 class="section-title">
              <span class="section-icon">📄</span>
              Domyślne wartości ofert
            </h2>
            <p class="section-description">
              Ustaw domyślne wartości automatycznie wstawiane przy tworzeniu nowej oferty
            </p>
          </div>
          <div class="section-body">
           
            <div class="form-group">
              <label class="form-label">Nagłówek oferty</label>
              <textarea
                class="form-textarea"
                v-model="defaultOfferTitle"
                rows="3"
                placeholder="np. Oferta na dostawę i montaż..."
              ></textarea>
            </div> 
            <div class="form-group">
              <label class="form-label">Nagłówek tabeli</label>
              <input
                class="form-input"
                v-model="defaultOfferHeader"
                type="text"
                placeholder="np. PROMOCJA ZIMOWA 2026"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Szczegóły oferty</label>
              <textarea
                class="form-textarea"
                v-model="defaultOfferDetails"
                rows="4"
                placeholder="np. Zakres prac obejmuje..."
              ></textarea>
            </div>
            <div class="form-group">
              <label class="form-label">Uwagi do oferty</label>
              <textarea
                class="form-textarea"
                v-model="defaultOfferNotes"
                rows="4"
                placeholder="np. Termin realizacji: 14 dni od daty podpisania umowy..."
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Sekcja 4: Domyślne ceny produktów -->
        <div class="settings-section">
          <div class="section-header">
            <h2 class="section-title">
              <span class="section-icon">💰</span>
              Domyślne ceny produktów
            </h2>
            <p class="section-description">
              Ustaw domyślne produkty i ceny używane przy tworzeniu oferty
            </p>
          </div>
          <div class="section-body">
            <div v-for="(item, index) in defaultProducts" :key="index" class="product-row">
              <div class="product-fields">
                <div class="form-group">
                  <label class="form-label">Nazwa produktu</label>
                  <input
                    class="form-input"
                    v-model="item.name"
                    type="text"
                    placeholder="np. Klimatyzator"
                  />
                </div>
                <div class="form-group form-group-small">
                  <label class="form-label">Jednostka</label>
                  <input
                    class="form-input"
                    v-model="item.measure"
                    type="text"
                    placeholder="szt/mb"
                  />
                </div>
                <div class="form-group form-group-small">
                  <label class="form-label">Ilość</label>
                  <input
                    class="form-input"
                    v-model.number="item.amount"
                    type="number"
                    step="0.01"
                    placeholder="1"
                  />
                </div>
                <div class="form-group form-group-small">
                  <label class="form-label">Cena netto</label>
                  <input
                    class="form-input"
                    v-model.number="item.price"
                    type="number"
                    step="0.01"
                    placeholder="0.00"
                  />
                </div>
                <button class="btn-delete-product" @click="removeProduct(index)" title="Usuń produkt">
                  🗑️
                </button>
              </div>
            </div>
            <button class="btn-add-product" @click="addProduct()">
              <span class="plus-icon">+</span>
              Dodaj produkt
            </button>
          </div>
        </div>

        <!-- Sticky footer z przyciskami -->
        <div class="settings-footer">
          <button
            type="submit"
            class="btn-save"
          >
            <span class="btn-icon">✓</span>
            Zapisz zmiany
          </button>
          <button
            type="button"
            @click="logout()"
            class="btn-logout"
          >
            <span class="btn-icon">🚪</span>
            Wyloguj się
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { auth } from "../firebase";

export default {
  data() {
    return {
      name: "",
      limitContractors: null,
      limitInstallations: null,
      limitPayments: null,
      limitMagazine: null,
      defaultOfferHeader: "Szczegółowa kalkulacja cenowa: Klimatyzator z Wi-Fi <span style='color:red'>5 Lat Gwarancji</span>",
      defaultOfferTitle: "Niniejsza oferta cenowa zawiera szczegółową kalkulację na dostawę,<br />montaż i uruchomienie klimatyzatora.",
      defaultOfferDetails: "W ramach przedstawionej oferty gwarantujemy: <br /><br /> ➢ Stały serwis gwarancyjny na wykonane roboty i dostarczone urządzenia <br /> ➢ Serwis konserwatorski po upływie okresu gwarancyjnego <br /> ➢ Serwis sprzątający podczas instalacji urządzeń klimatyzacyjnych  <br />➢ Szkolenie z zakresu obsługi urządzenia",
      defaultOfferNotes: "Oferta ważna 14 dni.",
      defaultProducts: [
        {id: 1, name: 'Klimatyzator', measure: 'szt', amount: 1, price: 0},
        {id: 2, name: 'Instalacja miedziana', measure: 'mb', amount: 1, price: 29.50},
        {id: 3, name: 'Instalacja sterująca', measure: 'mb', amount: 1, price: 6.50},
        {id: 4, name: 'Elementy montażowe', measure: 'szt', amount: 1, price: 150},
        {id: 5, name: 'Wspornik skraplacza', measure: 'szt', amount: 1, price: 75},
        {id: 6, name: 'Dostawa, montaż oraz uruchomienie', measure: 'szt', amount: 1, price: 650}
      ],
      showToast: false,
    };
  },
  methods: {
    loadOfferDefaults(othersArray) {
      // Załaduj globalne domyślne wartości ofert z others
      const offerDefaults = othersArray.find(item => item.id === 'offerDefaults');
      if (offerDefaults) {
        console.log('Ładowanie domyślnych wartości ofert:', offerDefaults);
        // Załaduj tylko niepuste wartości z Firebase
        if (offerDefaults.header && offerDefaults.header.trim() !== '') {
          this.$set(this, 'defaultOfferHeader', offerDefaults.header);
        }
        if (offerDefaults.title && offerDefaults.title.trim() !== '') {
          this.$set(this, 'defaultOfferTitle', offerDefaults.title);
        }
        if (offerDefaults.details && offerDefaults.details.trim() !== '') {
          this.$set(this, 'defaultOfferDetails', offerDefaults.details);
        }
        if (offerDefaults.notes && offerDefaults.notes.trim() !== '') {
          this.$set(this, 'defaultOfferNotes', offerDefaults.notes);
        }
        this.$forceUpdate();
      }
      
      // Załaduj globalne domyślne produkty z others
      const offerProducts = othersArray.find(item => item.id === 'offerProducts');
      if (offerProducts && offerProducts.items && offerProducts.items.length > 0) {
        console.log('Ładowanie domyślnych produktów:', offerProducts.items);
        this.$set(this, 'defaultProducts', [...offerProducts.items]);
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
    addProduct() {
      const newId = this.defaultProducts.length > 0 
        ? Math.max(...this.defaultProducts.map(p => p.id)) + 1 
        : 1;
      this.defaultProducts.push({
        id: newId,
        name: '',
        measure: 'szt',
        amount: 1,
        price: 0
      });
    },
    removeProduct(index) {
      this.defaultProducts.splice(index, 1);
    },
    updateProfile() {
      const limits = {
        contractors: this.limitContractors || this.defaultLimitContractors,
        installations: this.limitInstallations || this.defaultLimitInstallations,
        payments: this.limitPayments || this.defaultLimitPayments,
        magazine: this.limitMagazine || this.defaultLimitMagazine,
      };
      
      // Zapisz profil użytkownika (bez offerDefaults)
      this.$store.dispatch("updateProfile", {
        name: this.name !== "" ? this.name : this.userProfile.name,
        limits: limits,
      });
      
      // Zapisz globalne ustawienia ofert (dla wszystkich użytkowników)
      const offerDefaults = {
        header: this.defaultOfferHeader,
        title: this.defaultOfferTitle,
        details: this.defaultOfferDetails,
        notes: this.defaultOfferNotes,
      };
      
      console.log('Zapisuję domyślne wartości ofert:', offerDefaults);
      this.$store.dispatch("updateOfferDefaults", offerDefaults);
      
      // Zapisz globalne domyślne produkty (dla wszystkich użytkowników)
      console.log('Zapisuję domyślne produkty:', this.defaultProducts);
      this.$store.dispatch("updateOfferProducts", {
        items: this.defaultProducts
      });
      
      this.showSuccessToast();
    },
    showSuccessToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
  },

  computed: {
    ...mapState(["userProfile", "others", "contractors", "installations", "payments", "magazine"]),
    currentUserEmail() {
      // Pobierz email bezpośrednio z Firebase Auth
      const user = auth.currentUser;
      if (user && user.email) {
        return user.email;
      }
      // Fallback do store
      if (this.$store.state.currentUser && this.$store.state.currentUser.email) {
        return this.$store.state.currentUser.email;
      }
      // Ostatni fallback do userProfile
      return this.userProfile && this.userProfile.email ? this.userProfile.email : '';
    },
    defaultLimitContractors() {
      return (this.userProfile.limits && this.userProfile.limits.contractors) || 2000;
    },
    defaultLimitInstallations() {
      return (this.userProfile.limits && this.userProfile.limits.installations) || 1000;
    },
    defaultLimitPayments() {
      return (this.userProfile.limits && this.userProfile.limits.payments) || 1000;
    },
    defaultLimitMagazine() {
      return (this.userProfile.limits && this.userProfile.limits.magazine) || 1000;
    },
    contractorsCount() {
      return this.contractors ? this.contractors.length : 0;
    },
    installationsCount() {
      return this.installations ? this.installations.length : 0;
    },
    paymentsCount() {
      return this.payments ? this.payments.length : 0;
    },
    magazineCount() {
      return this.magazine ? this.magazine.length : 0;
    },
  },
  watch: {
    others: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          console.log('Watch others triggered, loading defaults...');
          this.loadOfferDefaults(newValue);
        }
      },
      immediate: true,
      deep: true
    },
    userProfile: {
      handler(newValue) {
        if (newValue && newValue.limits) {
          this.limitContractors = newValue.limits.contractors || null;
          this.limitInstallations = newValue.limits.installations || null;
          this.limitPayments = newValue.limits.payments || null;
          this.limitMagazine = newValue.limits.magazine || null;
        }
        if (newValue && newValue.name && this.name === '') {
          this.name = newValue.name;
        }
      },
      immediate: true,
      deep: false
    }
  },
  created() {
    // Spróbuj załadować dane po chwili (daj czas Firebase)
    setTimeout(() => {
      if (this.others && this.others.length > 0) {
        console.log('Created timeout - loading defaults...');
        this.loadOfferDefaults(this.others);
      }
    }, 1000);
  },
  mounted() {
    // Spróbuj załadować dane od razu (jeśli już są dostępne)
    if (this.others && this.others.length > 0) {
      console.log('Mounted - loading defaults...');
      this.loadOfferDefaults(this.others);
    }
    
    // Dodatkowa próba po dłuższym czasie
    setTimeout(() => {
      if (this.others && this.others.length > 0) {
        console.log('Mounted delayed - loading defaults...');
        this.loadOfferDefaults(this.others);
      }
    }, 2000);
    
    // Załaduj dane płatności jeśli nie są załadowane
    if (!this.payments || this.payments.length === 0) {
      const limits = this.userProfile.limits || {};
      const limit = limits.payments || 1000;
      this.$store.dispatch("getPayments", { limit });
    }
    
    // Załaduj dane magazynu jeśli nie są załadowane
    if (!this.magazine || this.magazine.length === 0) {
      const limits = this.userProfile.limits || {};
      const limit = limits.magazine || 1000;
      this.$store.dispatch("getMagazine", { limit });
    }
  },
};
</script><style scoped>
/* Layout główny */
.user-settings-view {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f8f9fa;
}

/* Header */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 35px 40px;
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  flex: 1;
}

.page-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: white;
  letter-spacing: -0.5px;
}

.page-subtitle {
  margin: 8px 0 0 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
}

.btn-back {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  text-decoration: none;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateX(-4px);
}

/* Container */
.settings-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 100px;
}

/* Sekcje */
.settings-section {
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 2px solid #f0f0f0;
}

.settings-section:last-of-type {
  border-bottom: none;
  margin-bottom: 20px;
}

.section-header {
  margin-bottom: 25px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  font-size: 26px;
}

.section-description {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.section-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Pola formularza */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 12px;
  min-width: 30px;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #2d3748;
  transition: all 0.2s ease;
  background: white;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input:disabled {
  background: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

.form-input::placeholder {
  color: #a0aec0;
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  color: #2d3748;
  transition: all 0.2s ease;
  background: white;
  font-family: inherit;
  resize: vertical;
}

.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea::placeholder {
  color: #a0aec0;
}

.helper-text {
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

/* Info box */
.info-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(102, 126, 234, 0.05);
  border-left: 4px solid #667eea;
  border-radius: 8px;
  font-size: 14px;
  color: #4a5568;
}

.info-icon {
  font-size: 20px;
  flex-shrink: 0;
}

/* Sticky footer */
.settings-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 20px 40px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 100px;
  z-index: 100;
}

.settings-footer::before {
  content: '';
  flex: 1;
}

.settings-footer::after {
  content: '';
  flex: 1;
}

.btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.5);
}

.btn-logout {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.4);
}

.btn-logout:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(220, 53, 69, 0.5);
}

.btn-icon {
  font-size: 18px;
  font-weight: bold;
}

/* Toast powodzenia */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(72, 187, 120, 0.4);
  font-size: 15px;
  font-weight: 600;
  z-index: 1000;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Produkty */
.product-row {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.product-row:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
}

.product-fields {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.2fr auto;
  gap: 12px;
  align-items: center;
}

.form-group-small {
  flex: 0 1 auto;
}

.btn-delete-product {
  background: #dc3545;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.3s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-delete-product:hover {
  background: #c82333;
  transform: scale(1.05);
}

.btn-add-product {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(72, 187, 120, 0.3);
  margin-top: 8px;
}

.btn-add-product:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);
}

.plus-icon {
  font-size: 20px;
  font-weight: bold;
}

/* Responsywność */
@media (max-width: 768px) {
  .user-settings-view {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 25px 20px;
  }

  .page-title {
    font-size: 24px;
  }

  .settings-container {
    padding: 25px 20px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .settings-footer {
    flex-direction: column;
    padding: 15px 20px;
  }

  .btn-save,
  .btn-logout {
    width: 100%;
    justify-content: center;
  }
}
</style>